module.exports = __webpack_public_path__ + "img/increase.be8cbbc6.svg";